export const chartPadding = {
  top: 0,
  bottom: 10,
  left: 0,
  right: 20,
}
